/**
 * SEO 配置 - models (日本語)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - フラッグシップAI動画ジェネレーター | WeryAI',
        description: 'Google Veo 3.1：ネイティブオーディオとフレームコントロールを備えたフラッグシップAI動画モデル。',
        keywords: 'Google Veo 3.1, フラッグシップAI動画, AI動画ジェネレーター, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 高品質AI動画生成 | WeryAI',
        description: 'Google Veo 3で高品質AI動画を生成。強力なモーション一貫性とネイティブオーディオをサポート。',
        keywords: 'Veo 3, Google Veo, AI動画制作, テキストから動画, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 超高速AI動画生成 | WeryAI',
        description: 'Google Veo 3 Fastで高画質AI動画を素早く生成。キャラクター一貫性と超高速レンダリングをサポート。',
        keywords: 'Veo 3 Fast, 超高速AI動画, キャラクター一貫性, テキストから動画, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 物理シミュレーション級AI動画生成 | WeryAI',
        description: 'OpenAI Sora 2で物理法則に準拠した超リアルな動画を生成。マルチショット叙事と精密な制御をサポート。',
        keywords: 'Sora 2, OpenAI Sora, 物理シミュレーション, リアルAI動画, テキストから動画, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - フラッグシップ・ネイティブAI動画ジェネレーター | WeryAI',
        description: 'WeryAI Video 1.0：ネイティブマルチショット叙事、スマート画像から動画、物理級モーションシミュレーションをサポートするフラッグシップAI動画モデル。',
        keywords: 'WeryAI Video 1.0, WeryAI ネイティブモデル, AI動画ジェネレーター, マルチショット叙事, 画像から動画, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - スタジオ品質AI画像ジェネレーター | WeryAI',
        description: 'WeryAI Image 2.0：卓越したテキストレンダリングと超リアルなディテールをサポートするフラッグシップAI画像モデル。',
        keywords: 'WeryAI Image 2.0, スタジオ級AI, AI画像ジェネレーター, プロAIデザイン, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 画像ジェネレーター - xAI 超リアルAI画像 | WeryAI',
        description: 'WeryAIでxAIのGrok-2を体験。Flux.1アーキテクチャに基づき、驚くほどリアルな効果を提供。',
        keywords: 'Grok-2, xAI, Flux.1, リアルAI, AIアート, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - トップクラスAI動画ジェネレーター | WeryAI',
        description: 'Kling 2.5 Turboは卓越したカメラワーク制御と感情表現力を提供。映画級AI動画制作の最適な選択。',
        keywords: 'Kling 2.5 Turbo, Kling AI, 映画級動画, カメラワーク制御, 動画生成, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - プロAI動画編集・生成 | WeryAI',
        description: 'Runway Gen-4は深層プロンプト理解とスタイル一貫性を備えています。WeryAIで次世代AI動画編集を体験。',
        keywords: 'Runway Gen-4, Runway AI, 動画ジェネレーター, AI動画編集, テキストから動画, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - Eコマース＆ダイナミックAI動画 | WeryAI',
        description: 'Hailuo 2.3はダイナミックアクションとEコマース広告に最適化。繊細な表情と物体モーション制御を提供。',
        keywords: 'Hailuo 2.3, Hailuo AI, MiniMax, Eコマース動画, ダイナミックAI動画, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI動画ジェネレーター - 高度なモーション制御 | WeryAI',
        description: 'Hailuo AIで高度なAI動画を生成。最先端のモーションシミュレーションとリアルなシーンレンダリング機能を搭載。',
        keywords: 'Hailuo AI, Hailuo AI, モーション制御, リアル動画, 動画ジェネレーター, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 高画質・繊細なAIアニメーション生成 | WeryAI',
        description: 'WeryAIでPika 2.2を体験し、クリアでシャープな高画質AIアニメーションを生成。精密なキャラクター制作に最適。',
        keywords: 'Pika 2.2, Pika AI, AIアニメーション, 高画質動画, 動画ジェネレーター, WeryAI',
    },
    seedance: {
        title: 'Seedance AI動画ジェネレーター - ダンス＆モーション制作 | WeryAI',
        description: 'Seedanceでリアルでプロフェッショナルなダンス動画を生成。',
        keywords: 'Seedance, AI動画, WeryAI',
    },
    wan_2_6: {
        title: 'Wan 2.6 | Alibabaの先進的AI動画ジェネレーター | WeryAI',
        description: 'Wan 2.6 は、Alibabaの最新フラッグシップ多モーダルAI動画生成モデル。シネマティックな1080p品質、ネイティブな音声・映像同期、スマートなマルチショット叙事機能を搭載。WeryAIで無料でお試し。',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, AI動画ジェネレーター, マルチモーダル動画モデル, テキストから動画, 画像から動画, オーディオ同期, WeryAI Wan 2.6',
    },
    wan_ai: '',
    image_gpt_4o: {
        title: 'GPT-4o 画像生成器 - OpenAI ネイティブ画像AI | WeryAI',
        description: 'GPT-4oを使用してAI画像を生成。強力な意味理解と高品質なビジュアル出力。WeryAIで無料でお試し。',
        keywords: 'GPT-4o, OpenAI 画像, AIアート, 画像生成, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro 画像生成 | WeryAI',
        description: '推論駆動型AI画像大モデル。4K超リアル画質と完璧なテキストレイアウトをサポート。',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, AI画像生成, 4K画像生成, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash 超高速描画 | WeryAI',
        description: 'Google DeepMindが開発した超高速・高一貫性AI画像ジェネレーター。自然言語編集と多画像融合をサポート。',
        keywords: 'Nano Banana, Gemini 2.5 Flash, 超高速描画, キャラクター一貫性, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI画像ジェネレーター - トップオープンソース描画大モデル | WeryAI',
        description: 'FLUXは元Stable Diffusionチームが開発。卓越した視覚品質と正確なプロンプト遵守能力を提供。',
        keywords: 'FLUX, Black Forest Labs, AI描画, テキストから画像, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - プロ級AI描画強化版 | WeryAI',
        description: 'FLUX.1 ProとMaxバージョンを体験。より強力なテキストレンダリングとキャラクター一貫性を備えています。デザイナーとクリエイティブプロフェッショナル向けに設計。',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, プロ描画, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Google高度テキストから画像拡散モデル | WeryAI',
        description: '写真級、芸術的、抽象的な画像を生成。Google Imagen 4は多様なスタイル制御と高品質レンダリングを提供。',
        keywords: 'Imagen 4, Google AI描画, 拡散モデル, アート生成, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Alibabaオープンソーステキストレンダリングモデル | WeryAI',
        description: 'Alibaba Qwen Imageモデルは多言語テキストレンダリングとスタイル化された創作に特化。無料でプロ級ビジュアル素材を生成。',
        keywords: 'Qwen Image, 通義千問, Alibaba AI描画, 多言語テキスト, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 画像生成 - Alibaba高忠実度テキストから画像大モデル | WeryAI',
        description: 'Wan 2.5は正確なプロンプト遵守と写真級レンダリング機能をサポート。Alibabaの最新高忠実度AI描画技術。',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI描画, 高忠実度画像, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDanceバッチ4K描画モデル | WeryAI',
        description: 'ByteDanceが発表した超高速描画モデル。バッチ処理と4K高画質レンダリングをサポート。強力なキャラクター一貫性制御機能を搭載。',
        keywords: 'Seedream, ByteDance AI, バッチ描画, 4K画像, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDanceオールインワンAI画像創作モデル | WeryAI',
        description: 'Dreamina 4.0は手描き変換、スタイル転移、多キャラクター融合をサポート。ByteDanceのトップ商用描画大モデル。',
        keywords: 'Dreamina 4.0, 即夢AI, 手描き変換, スタイル転移, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDanceフラッグシップAI画像生成モデル | WeryAI',
        description: 'Seedream 4.5はByteDanceの最新フラッグシップAI画像モデルで、精密な文字レンダリングとマルチ画像融合、4K超高画質出力に対応。WeryAIで無料体験。',
        keywords: 'Seedream 4.5, AI画像生成, 文字レンダリング, マルチ画像融合, ByteDance, 4K画質, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - 柔軟で詳細、かつ鮮やかな画像生成 | WeryAI',
        description: 'Midjourneyは独立研究ラボMidjourney Inc.による最新世代のフラッグシップAI画像モデルです。WeryAIで無料体験。',
        keywords: 'Midjourney, AI画像生成, アート作成, ライティング品質, テキストレンダリング, 超リアルなポートレート, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI動画ジェネレーター - 映画級動画を作成 | WeryAI',
        description: 'WeryAIでRunway Gen-4.5を使用して驚くべき動画を作成。自己回帰拡散ハイブリッドアーキテクチャで精密な物理シミュレーションと時系列一貫性を提供。',
        keywords: 'Runway Gen-4.5, AI動画ジェネレーター, 映画級AI動画, 物理シミュレーション, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI動画ジェネレーター - 高品質動画制作 | WeryAI',
        description: 'WeryAIでKling 2.6 Proを使用して高品質動画を生成。ネイティブ音声映像生成、1080p映画品質、優れたプロンプト遵守能力。',
        keywords: 'Kling 2.6 Pro, AI動画ジェネレーター, 高品質AI動画, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 動画ジェネレーター - 精密なカメラ制御と首尾フレーム指導 | WeryAI',
        description: 'WeryAIでDreamina 3.0（即夢3.0）を使用して映画級AI動画を生成。首尾フレーム精密制御、プロ運鏡と1080p高ダイナミック動画生成をサポート。',
        keywords: 'Dreamina 3.0, 即夢3.0, AI動画ジェネレーター, 運鏡制御, 首尾フレーム制御, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI動画ジェネレーター - クリエイティブ動画生成 | WeryAI',
        description: 'WeryAIでKling O1 AI動画ジェネレーターを使用して創造力を解放。想像力豊かでユニークな動画コンテンツの生成に最適。',
        keywords: 'Kling O1, AI動画ジェネレーター, クリエイティブAI動画, Kling AI, WeryAI',
    },
}
